import React, { useEffect, useState, useMemo } from 'react';
import './Form.css';
import Services from '../services/Services';
import CircularProgress from './CircularProgress';
import Modal from './Modal';

function Form({ token, campaignID }) {
  const [name, setName] = useState('');
  const [surname, setSurname] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [kvkk, setKvkk] = useState(false);
  const [agreement, setAgreement] = useState(false);
  const [followUp, setFollowUp] = useState(false);
  const [avonStandCheckbox, setAvonStandCheckbox] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [campaignTitle, setCampaignTitle] = useState('');

  const [showModal, setShowModal] = useState(false);
  const [resultMessage, setResultMessage] = useState('Başvurunuz başarıyla alınmıştır.');
  const [modalContent, setModalContent] = useState('');

  const [showKVKKModal, setShowKVKKModal] = useState(false);
  const [showAgreementModal, setShowAgreementModal] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [companyID, setCompanyID] = useState('');

  // ---- Kupon Durumu & Modal ----
  const [poiID, setPoiID] = useState('');
  const [hasCoupon, setHasCoupon] = useState(null);  // null: bilinmiyor
  const [hadCoupon, setHadCoupon] = useState(false); const [couponModalOpen, setCouponModalOpen] = useState(false);
  const [couponLoading, setCouponLoading] = useState(false);
  const [couponData, setCouponData] = useState(null);
  const [couponError, setCouponError] = useState('');

  // ---- AVON - Stand Başvurusu için yeni alanlar ----
  const WEEK_DAYS = ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar'];

  const [workingHoursStart, setWorkingHoursStart] = useState('');
  const [workingHoursEnd, setWorkingHoursEnd] = useState('');
  const [closedDays, setClosedDays] = useState([]);
  const [hasOneSquareMeter, setHasOneSquareMeter] = useState('');

  const resetForm = () => {
    setName('');
    setSurname('');
    setPhone('');
    setEmail('');
    setKvkk(false);
    setAgreement(false);
    setFollowUp(false);
    setAvonStandCheckbox(false);
    setWorkingHoursStart('');
    setWorkingHoursEnd('');
    setClosedDays([]);
    setHasOneSquareMeter('');
  };

  const SUCCESS_MSGS = useMemo(() => ({
    avonStand:
      'Tebrikler! Mağazan önünde Avon Stand kurulumu için başvurun alındı. Avon saha ekibi talebinle ilgili detaylar hakkında görüşmek üzere takip eden hafta içerisinde seninle iletişime geçecekler.',
    avonTemsilci:
      'Tebrikler! Avon Temsilcilik başvurun alındı. Avon Temsilciliğini tamamlamak üzere Avon satış lideri en kısa sürede seninle iletişime geçecek.',
    generic:
      `Başvuru talebiniz alınmıştır. Başvurunuz için ${companyName} tarafından 24 saat içerisinde aranacaksınız.`,
  }), [companyName]);

  const kvkkText = `
    <h1 style="text-align: center; font-size: 24px; font-weight: bold;">AVM LOJİSTİK TİCARET A.Ş.</h1>
    <h2 style="text-align: center; font-size: 20px;">6698 SAYILI KİŞİSEL VERİLERİN KORUNMASI KANUNU GEREĞİNCE</h2>
    <h2 style="text-align: center; font-size: 20px;">EASY POINT AYDINLATMA METNİ</h2>

    <h3 style="font-size: 18px; font-weight: bold;">A. Veri Sorumlusunun Kimliği ve Tanımlar</h3>
    
    <p style="font-size: 16px;">6698 sayılı Kişisel Verilerin Korunması Kanunu (“Kanun”) uyarınca, veri sorumlusu sıfatıyla hareket eden AVM Lojistik Ticaret Anonim Şirketi (“Şirket” “AVM Lojistik”) tarafından kişisel verilerinizin korunmasına büyük önem verilmektedir. AVM Lojistik, Easy Point markası adı altında, bu sıfatın gerektirdiği yükümlülükleri yerine getirmek için gerekli uyum çalışmalarını gerçekleştirmektedir. İşbu bilgilendirme, İlgili kişilerin, şirketimizce hizmet verilen Easy Point Esnaf Noktalarında Digiturk’ün ürünleri ile ilgilenmesi halinde kendisi ile iletişime geçilebilmesi adına, ilgili hizmet(ler)in verilebilmesi için Esnaf iş yeri tarafından şirketimiz adına kayıt alma işleminin gerçekleştirilmesi hususunda; tüm ilgili gerçek kişileri kapsaması adına, işlenebilecek kişisel verilere, bunların işlenme amaçlarına ve kişisel verilerin aktarıldığı taraflara ilişkin bilgilere dair Kanun kapsamında aydınlatma yükümlülüğünü yerine getirmek üzere yapılmaktadır. </p>

    <p style="font-size: 16px;"> 
    Kişilerin yararlandığı hizmetler ya da talep ve rızaları vb. hususlar kişiden kişiye farklılık gösterebileceğinden, aşağıda yer verilen tüm bilgiler her gerçek kişi için söz konusu olmayacaktır. İşbu Aydınlatma Metni gerekli olduğu durumlarda Şirketimiz tarafından güncellenecek ve güncel hali yayımlanacaktır.  
    </p>

    <h3 style="font-size: 18px; font-weight: bold;">B. Toplanan Kişisel Veriler, Veri Toplamanın Yöntemi ve Hukuki Sebebi</h3>
    <p style="font-size: 16px;">Kişisel veriler, kimliğinizi belirleyen ya da belirlenebilir kılan bilgiler anlamına gelmektedir, Şirketimiz tarafından işlenebilecek kişisel verileriniz aşağıda yer alanlar ile sınırlı olmamakla,  </p>

    <p style="font-size: 16px;">Kimlik Bilgileri : Ad- Soyad,</p>
    <p style="font-size: 16px;">İletişim Bilgileri: Telefon, e-mail adresidir.  </p>
    <p style="font-size: 16px;">Cookie Çerez Bilgileri: İnternet sayfası üzerinden, hizmetin kullanılmasına ilişkin tercihler, alışkanlıklar, davranış bilgileri, çerezler, giriş yapılan hesap bilgileri, cihaz, şebeke, ağ, uygulama, konum bilgileri işlenmektedir.</p>

    <p style="font-size: 16px;">Şirketimiz, 6698 sayılı Kişisel Verilerin Korunması Kanunu çerçevesinde, kişisel verileri tamamen veya kısmen otomatik ya da veri kayıt sisteminin parçası olmak kaydıyla otomatik olmayan yollarla, sözlü, yazılı veya elektronik şekilde (Easy Point Esnaf App) kanuna uygun olarak toplamakta, Kanunun 5. ve 6. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları dahilinde bu metnin C ve D bendinde belirtilen amaçlarla işleyebilmekte ve aktarabilmektedir.</p>

    <h3 style="font-size: 18px; font-weight: bold;">C. Kişisel Verilerin Hangi Amaçla İşleneceği  </h3>
    <p style="font-size: 16px;">Kişisel verileriniz aşağıdaki durumlarda Kanuna uygun olarak işlenebilmektedir. </p>

    <ul style="font-size: 16px;">
        <li>Kayıt oluşturulması ve doğrulanması, </li>
        <li>Hizmetin sunulabilmesi adına hizmet sözleşmesinin oluşturulması, </li>
        <li>Hizmetlerin sunulması, ücretlendirilmesi ve faturalandırılması; hizmetlerle ilgili talep ettiğiniz işlemlerin gerçekleştirilmesi ve takibinin sağlanması,</li>
        <li>Hizmetlerin tanıtım ve pazarlaması, bunlara ilişkin sizinle iletişime geçilmesi, kampanya, indirim, fayda, koşul, ücretlendirme gibi hususlardan haberdar edilmeniz; üyelik, etkinliklerden yararlanma gibi olanaklar sağlanması ve bunların kullanımı için gerekli işlemlerin yerine getirilmesi,</li>
        <li> Gerekli durumlarda bilgilerinizin teyit edilmesi;   </li>
        <li>  Size teklif, hediye ve promosyon sunulması, hedefli tanıtım yapılması; size özel kutlama, temenni iletimi, ödül, çekiliş ve beğendiğiniz, tekrar erişmek isteyebileceğiniz, hatırlatılmasından memnuniyet duyabileceğiniz içeriklerin iletilmesi; ödül, çekiliş, yarışmaya ya da benzer bir etkinliğe katılmanız halinde bu kapsamda verdiğiniz bilgilerin etkinlik için kullanılması,   </li>
        <li> Hizmetlerin geliştirilmesi, denetimi ve analizi ile çalışanların eğitimi gibi dahili amaçlar için kullanılması; hizmetlere olan ilginizin değerlendirilmesi, müşteri/kullanıcı memnuniyetinin araştırılması; sizden gelecek soru, şikâyet ve bildirimlerin cevaplanması,   </li>
        <li> İlgili mevzuat gereği saklanması gereken bilgilerinizin muhafazası; bilgi kayıplarının önlenebilmesi için kopyalanması, yedeklenmesi; bilgilerinizin tutarlılığının kontrolünün sağlanması, bilgilerinizin güvenliği için gerekli tüm teknik ve idari tedbirlerin alınması,   </li>
        <li> Üst yönetime yapılacak raporlama ve analizlerin hazırlanması amacıyla.   </li>
        <li> Kanun ve yönetmelikler ile belirlenmiş gerekliliklerin ifa edilmesi (vergi mevzuatı, sosyal güvenlik mevzuatı, borçlar hukuku mevzuatı, ticaret hukuku mevzuatı, iş sağlığı ve güvenliği hukuku, elektronik iletişim ile ilgili mevzuat vs. ilgili tüm mevzuatlar).   </li>
        <li> e-fatura, e-arşiv ve e-irsaliye ile ilgili yükümlülüklerin yerine getirilmesi.   </li>
        <li> Yasal düzenlemelerin gerektirdiği veya zorunlu kıldığı şekilde kamu kurum ve kuruluşlarının taleplerinin yerine getirilmesi.   </li>
        <li> Kanunda belirtilmiş yasal yükümlülüklerin yerine getirilmesi.   </li>
    </ul>

    <h3 style="font-size: 18px; font-weight: bold;">D. İşlenen Kişisel Verilerin Kimlere ve Hangi Amaçla Aktarılabileceği  </h3>
    <p style="font-size: 16px;">İşlenen kişisel verileriniz zorunlu olan bilgiler ile sınırlı olmak kaydı ile yurtiçinde, </p>
    <ul style="font-size: 16px;">
        <li>Abonelik sözleşmesi akdedilmesi, teklif, fırsat, kampanya ve promosyon, hediyeler verilebilmesi için şirketimiz ile arasında İş birliği Protokolü imzalanan iş ortaklarımıza ve tedarikçilerimizle, </li>
        <li>Yazılım, kurumsal kaynak planlaması, raporlama, pazarlama vb. gibi işlevlerin yerine getirilmesi amacıyla tedarikçilerle ve çözüm ortaklarıyla,  </li>
        <li>Gerekli kalite, gizlilik ve standart denetimlerinin yapabilmesi amacıyla denetim firmaları ve bilgi güvenliği firmalarıyla,  </li>
        <li>Şirketimiz adına veri işleyen (IT desteği veren, trafik/müşteri-misafir memnuniyeti ölçümleme, profilleme ve segmentasyon desteği veren, satış ve pazarlama alanında sms, mailing, arşivleme başta olmak üzere kişisel verilerin işlenmesi gereken konularda destek veren) firmalarla,  </li>
        <li>İlgili mevzuat hükümlerine istinaden yükümlülüklerimizin yerine getirilmesi ve ticari faaliyetlerimizin denetimi amacıyla ilgili denetim firmalarıyla, bağımsız denetim firmalarıyla, gümrük firmalarıyla, mali müşavir/muhasebe firmalarıyla, hukuk bürolarıyla,  </li>
        <li>Şirket’in kendi iştirakleri, markaları, hissedarları ve ortaklarına, </li>
        <li>Şirket tarafından kurulan ortak veri tabanının işlerliği açısından ilgili tedarikçilerle</li>
        <li>Yasal gereklilikleri ifa etmek ve/veya resmi mercilerin taleplerini yerine getirmek amacıyla kamu kurum ve kuruluşlarıyla, paylaşılabilir. </li>
    </ul>

    <h3 style="font-size: 18px; font-weight: bold;">E. İlgili Kişinin Hakları  </h3>
    <p style="font-size: 16px;">Kanun kapsamında, kişisel verilerinize ilişkin olarak aşağıdaki haklara sahipsiniz. </p>
    
    <ul style="font-size: 16px;">
        <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme. </li>
        <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme. </li>
        <li>Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme. </li>
        <li>Yurt içinde veya yurt dışında kişisel verileriniz aktarıldığı üçüncü kişileri bilme. </li>
        <li>Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme. </li>
        <li>Kişisel verilerinizin işlenmesini gerektiren sebeplerin ortadan kalkması hâlinde, Kanun kapsamında kişisel verilerin silinmesini veya yok edilmesini isteme. </li>
        <li>Talebinizce düzeltilen veya silinen veya yok edilen kişisel verilerinizin, eğer aktarılmışsa, aktarıldığı üçüncü kişilere bildirilmesini isteme. </li>
        <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle sizin aleyhinize bir sonucun ortaya çıkmasına itiraz etme. </li>
        <li>Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme. </li>
    </ul>

     <p style="font-size: 16px;">İlgili kişi olarak başvurunuzu, internet sitesinde yer alan, https://www.easypoint.com.tr/6698-sayili-kisisel-verilerin-korunmasi-kanunu-geregince-basvuru-formu/ doldurulduktan sonra veya usulüne uygun bir dilekçe hazırladıktan sonra bir nüshasının bizzat elden veya yazılı olarak iadeli taahhütlü posta aracılığı ile Gazi Umur Paşa Sokak Bimar İş Merkezi No:38 D:13 K:4 Beşiktaş/İstanbul adresine iletilmesi veya şahsen başvuru yapması ile, https://www.easypoint.com.tr/6698-sayili-kisisel-verilerin-korunmasi-kanunu-geregince-basvuru-formu/ İlgili Kişi Başvuru formunun doldurulması ve 5070 Sayılı Elektronik İmza Kanunu kapsamındaki “güvenli elektronik imza” ile imzalandıktan sonra güvenli elektronik imzalı formun info@malllogistics.com e-posta adresimize ya da avmlojistik@hs03.kep.tr kep adresine, kayıtlı elektronik posta ile gönderilebilir. Başvurunuzun geçerli bir başvuru olarak kabul edilebilmesi için  Veri Sorumlusuna Başvuru Usulleri Hakkında Tebliğ uyarınca başvuruda, ilgili kişinin; a) Ad, soyad ve başvuru yazılı ise imza, b) Türkiye Cumhuriyeti vatandaşları için T.C. kimlik numarası, yabancılar için uyruğu, pasaport numarası veya varsa kimlik numarası, c) Tebligata esas yerleşim yeri veya iş yeri adresi, ç) Varsa bildirime esas elektronik posta adresi, telefon ve faks numarası, d) Talep konusu, bilgilerini belirtmesi zorunludur. Aksi halde başvuru geçerli bir başvuru olarak değerlendirilmeyecektir. Başvuru formu doldurmadan yapılacak başvurularda burada sayılan hususların eksiksiz olarak AVM LOJİSTİK TİC.A.Ş’ ye iletilmesi gerekmektedir. Kişisel verisi işlenen ilgili kişilerin adına üçüncü kişilerin başvuru talebinde bulunabilmesi için ilgili kişi tarafından başvuruda bulunacak kişi adına noter kanalıyla düzenlenmiş özel vekâletname bulunmalıdır.  </p>

       <p style="font-size: 16px;">Bu kapsamda yapacağınız başvurular, talebin niteliğine göre en kısa sürede ve en geç otuz gün içinde ücretsiz olarak sonuçlandırır. Ancak, işlemin ayrıca bir maliyet gerektirmesi hâlinde, tarafınıza yazılı olarak cevap verilecekse, on sayfaya kadar ücret alınmaz. On sayfanın üzerindeki her sayfa için 1 Türk Lirası işlem ücreti alınabilir. Ayrıca, başvuruya cevabın CD, flash bellek gibi bir kayıt ortamında verilmesi halinde, Şirketimiz tarafından talep edilebilecek ücret kayıt ortamının maliyetini geçemez. Başvurunun, Şirketimizin hatasından kaynaklanması hâlinde alınan ücret tarafınıza iade edilir.</p>
  `
  const kvkkTextAvonStand = `
    <h1 style="text-align:center; font-size:20px; font-weight:bold;">AVM LOJİSTİK TİC. A.Ş - Avon Stand – Esnaf</h1>
    <h2 style="text-align:center; font-size:18px;">Kişisel Verilerin İşlenmesine İlişkin Açık Rıza Metni</h2>
    <p style="font-size:14px;">
      Gazi Umur Paşa Sokak Bimar Plaza No:38 Kat:4 D:13 Beşiktaş/İstanbul adresinde muhkim, AVM LOJİSTİK TİCARET A.Ş (“Şirket”) tarafından 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) kapsamında hazırlanmış olan “AVM Lojistik Tic. A.Ş Aydınlatma Metni’nin” (“Aydınlatma Metni”) tamamını okudum, anladım ve hangi kişisel verilerimi ne şekilde işlediği ve açık rızamı dilediğim zaman herhangi bir sınırlamaya tabi olmaksızın geri alabileceğim hakkında bilgilendirildim.
      Bu kapsamda şahsıma ait, ad soyad, iletişim no, 6698 sayılı Kişisel Verilerin Korunması Kanunu’na uygun olarak kanunda belirtilen ilkeler ve amaçlarla sınırlı kalmak kaydıyla, Avon stand hizmeti verebilme adına kayıt oluşturulması ve gerektiği hallerde tarafımla iletişim kurulabilmesi adına toplanmasına, işlenmesine, gerekli olan azami süre kadar saklanmasına ve işlenen kişisel verilerimin Şirketin iş ortağı AVON KOZMETİK ÜRÜNLERİ SANAYİ VE TİC. A.Ş’ye aktarılmasına açık rıza gösterdiğimi,
      işlenen kişiler verilerim ile ilgili, ilgili kanunun 11. Maddesinde belirtilen haklarımı kullanmayı talep ettiğim halde, <a href="mailto:info@malllogistics.com">info@malllogistics.com</a> adresine elektronik posta yolu ile veyahut Balmumcu Mah Gazi Umur Paşa Sokak Bimar Plaza No:38 Kat:4 D:13 Beşiktaş/İstanbul adresine bizzat elden, noter kanalıyla veya KVK Kanunu’nun 13. Maddesi uyarınca Kişisel Verileri Koruma Kurulu tarafından öngörülecek diğer yöntemler ile yazılı olarak müracaat edebileceğim hususunda herhangi şüpheye mahal vermeyecek şekilde bilgilendirildiğimi,
      İşbu Açık rıza metninde yer alan hususlarla alakalı olarak açık rıza vermiş olduğum kişisel verilerimin, yukarıda açıklanmış olan amaçlarla toplanmasına, işlenmesine, aktarılmasına ve saklanmasına hiçbir etki altında kalmadan, açık rıza veriyorum.
    </p>
  `;

  const kvkkTextAvonTemsilci = `
  <h1 style="text-align:center; font-size:20px; font-weight:700; margin:0 0 8px;">
    AVM LOJİSTİK TİCARET A.Ş.
  </h1>
  <h2 style="text-align:center; font-size:16px; font-weight:600; margin:0 0 4px;">
    6698 SAYILI KİŞİSEL VERİLERİN KORUNMASI KANUNU (KVKK) KAPSAMINDA
  </h2>
  <h2 style="text-align:center; font-size:18px; font-weight:700; margin:0 0 16px;">
    EASY POINT – ESNAF PLUS – AVON İŞ BİRLİĞİ Aydınlatma Metni
  </h2>

  <h3 style="font-size:16px; font-weight:700; margin:16px 0 8px;">A. Veri Sorumlusunun Kimliği ve Kapsam</h3>
  <p style="margin:0 0 8px;">
    6698 sayılı KVKK uyarınca veri sorumlusu AVM Lojistik Ticaret A.Ş. (“Şirket”, “AVM Lojistik”)
    kişisel verilerinizin korunmasına önem verir. Bu aydınlatma; Easy Point Esnaf Noktalarında
    <b>“Avon Temsilcisi olmak”</b> ile ilgilenen kişilere iletişim kurulabilmesi ve başvuru kaydının
    şirketimiz adına esnaf iş yeri tarafından alınmasına yönelik işleme faaliyetleri hakkında bilgi vermek amacıyla hazırlanmıştır.
  </p>

  <h3 style="font-size:16px; font-weight:700; margin:16px 0 8px;">B. Toplanan Kişisel Veriler, Yöntem ve Hukuki Sebep</h3>
  <p style="margin:0 0 8px;">
    İşlenebilecek kişisel veriler: <b>Ad–Soyad</b> (kimlik), <b>Telefon</b> (iletişim) ve
    <b>5651 sayılı Kanun kapsamında log kayıtları</b> gibi verilerle sınırlıdır.
  </p>
  <p style="margin:0 0 8px;">
    Verileriniz; sözlü, yazılı veya elektronik ortamda (Easy Esnaf Plus App) toplanır ve KVKK m.5/2
    <b>(c)</b> sözleşmenin kurulması/ifası, <b>(ç)</b> hukuki yükümlülük, <b>(e)</b> hakların tesisi/kullanılması/korunması,
    <b>(f)</b> meşru menfaat hukuki sebeplerine dayanılarak işlenir.
  </p>

  <h3 style="font-size:16px; font-weight:700; margin:16px 0 8px;">C. Kişisel Verilerin İşlenme Amaçları</h3>
  <ul style="margin:0 0 8px 18px; padding:0;">
    <li>Kayıt oluşturulması ve başvurunuzun takibi,</li>
    <li>Talep ettiğiniz işlemlerin gerçekleştirilmesi,</li>
    <li>Tarafınızdan iletilecek soru, şikâyet ve bildirimlerin cevaplanması.</li>
  </ul>

  <h3 style="font-size:16px; font-weight:700; margin:16px 0 8px;">D. Aktarımlar</h3>
  <p style="margin:0 0 8px;">
    Kişisel verileriniz; faaliyetlerin yürütülmesi kapsamında yalnızca gerekli olduğu ölçüde ve KVKK’ya uygun şekilde
    <b>Şirket’in iştirakleri/markaları/hissedarları/ortaklarına</b> ve <b>yasal gereklilikler</b> çerçevesinde
    <b>kamu kurum ve kuruluşlarına</b> aktarılabilir.
  </p>

  <h3 style="font-size:16px; font-weight:700; margin:16px 0 8px;">E. İlgili Kişi Hakları (KVKK m.11)</h3>
  <ul style="margin:0 0 8px 18px; padding:0;">
    <li>Verilerinizin işlenip işlenmediğini öğrenme,</li>
    <li>İşlenmişse buna ilişkin bilgi talep etme,</li>
    <li>İşleme amacını ve amaca uygun kullanılıp kullanılmadığını öğrenme,</li>
    <li>Yurt içi/yurt dışı aktarım yapılan üçüncü kişileri bilme,</li>
    <li>Eksik veya yanlış işlenmişse düzeltilmesini isteme,</li>
    <li>KVKK kapsamında silinmesini/yok edilmesini isteme,</li>
    <li>Aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
    <li>Münhasıran otomatik sistemlerle analiz sonucu aleyhe bir sonuca itiraz etme,</li>
    <li>Kanuna aykırı işlenme nedeniyle zararın giderilmesini talep etme.</li>
  </ul>

  <h3 style="font-size:16px; font-weight:700; margin:16px 0 8px;">F. Başvuru Yöntemi</h3>
  <p style="margin:0 0 8px;">
    Başvurularınızı, internet sitemizde yer alan
    <a href="https://www.easypoint.com.tr/6698-sayili-kisisel-verilerin-korunmasi-kanunu-geregince-basvuru-formu/" target="_blank" rel="noopener noreferrer">
      İlgili Kişi Başvuru Formu
    </a>
    ile veya usulüne uygun dilekçe/KEP/e-imza yöntemleriyle iletebilirsiniz.
    Formu doldurup ıslak imzalı olarak
    <b>Gazi Umur Paşa Sokak Bimar İş Merkezi No:38 D:13 K:4 Beşiktaş/İstanbul</b> adresine elden/posta ile
    iletebilir; ya da 5070 sayılı Kanun kapsamında güvenli e-imza ile
    <a href="mailto:info@malllogistics.com">info@malllogistics.com</a> adresine veya KEP üzerinden
    <b>avmlojistik@hs03.kep.tr</b> adresine gönderebilirsiniz.
  </p>
  <p style="margin:0 0 8px;">
    Başvurularınız talebin niteliğine göre en kısa sürede ve en geç 30 gün içinde sonuçlandırılır.
    Yazılı yanıtın 10 sayfayı aşması halinde her ilave sayfa için 1 TL işlem ücreti alınabilir;
    CD/flash bellek gibi ortamlar için maliyeti aşmayacak ücret talep edilebilir.
  </p>
`;
  // Kampanya + şirket bilgisi
  useEffect(() => {
    setIsLoading(true);
    Services.GetBolParaCampaign(token, campaignID)
      .then((res) => {
        if (res.data?.status) {
          const cmpId = res.data.result.companyID;
          setCompanyID(cmpId);
          setCampaignTitle(res.data.result.title);

          // Şirket adı
          gelBolParaCompany(cmpId);
          // PoiID (gerekirse)
          fetchPoiID();

          // Form ilk açıldığında kupon var mı yok mu kontrol et
          checkHasCoupon(cmpId, campaignID);
        } else {
          setCampaignTitle('Bir hata ile karşılaşıldı');
          setIsLoading(false);
        }
      })
      .catch(() => setIsLoading(false));
  }, [token, campaignID]);

  const gelBolParaCompany = (cmpId) => {
    Services.GetBolParaCompanies(token)
      .then((res) => {
        if (res.data?.status) {
          const company = res.data.result.find((x) => x.companyID === cmpId);
          if (company) setCompanyName(company.title || '');
        }
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  };

  const fetchPoiID = () => {
    Services.BolParaAboutToken(token)
      .then((res) => {
        if (res?.data?.status) {
          setPoiID(res.data.result?.easypointID || '');
        }
      })
      .catch((err) => { console.log(err) });
  };

  // Kupon var mı?
  const checkHasCoupon = (cmpId, campId) => {
    setHasCoupon(null);
    Services.GetBolParaCampaignHasCoupon(token, cmpId, campId)
      .then((res) => {
        const status = res?.data?.status === true;

        if (!status) {
          setHasCoupon(false);
          setHadCoupon(false);
          return;
        }

        const result = res?.data?.result;

        if (result && typeof result === "object") {
          // { hasCoupon: boolean, hadCoupon: boolean }
          const hc = Boolean(result.hasCoupon);
          const hd = Boolean(result.hadCoupon);
          setHasCoupon(hc);
          setHadCoupon(hd);
        } else {
          // result YOKSA: "kupon girildi ve VAR" anlamı → buton aktif
          setHasCoupon(true);
          setHadCoupon(true);
        }
      })
      .catch(() => { setHasCoupon(false); setHadCoupon(false); });
  };

  const isAvonTemsilci = useMemo(
    () => companyName === 'Avon' && campaignTitle === 'Avon Temsilci Aday Başvurusu',
    [companyName, campaignTitle]
  );

  const isAvonStand = useMemo(
    () => companyName === 'Avon' && campaignTitle === 'Avon Stand Başvurusu',
    [companyName, campaignTitle]
  );

  const sendApplication = (data) => {
    Services.SaveBolParaCampaignResponse(token, campaignID, data)
      .then((res) => {
        setIsLoading(false);

        if (res.data?.status) {
          resetForm();

          // --- GÜNCELLE: Mesajı kampanyaya göre belirle ---
          let msg = SUCCESS_MSGS.generic;
          if (isAvonStand) msg = SUCCESS_MSGS.avonStand;
          else if (isAvonTemsilci) msg = SUCCESS_MSGS.avonTemsilci;

          setResultMessage(msg);

          if (companyID) {
            if (hasCoupon === true && hadCoupon === true) {
              // Kuponu çekmeyi dene
              fetchAndShowCoupon(companyID, campaignID);
              return;
            }
            if (hasCoupon === false && hadCoupon === true) {
              // Kupon stoğu tükenmiş bilgisini göster
              setCouponData(null);
              setCouponError('Üzgünüz, bu kampanyanın kuponları tükenmiştir.');
              setCouponLoading(false);
              setCouponModalOpen(true);
              return;
            }
          }

          // Default: sadece sonuç modali
          setShowModal(true);
        } else {
          resetForm();
          setResultMessage('Başvurunuz alınırken bir sorunla karşılaşıldı.');
          setShowModal(true);
        }
      })
      .catch(() => {
        setIsLoading(false);
        setShowModal(true);
        setResultMessage('Başvuru gönderilirken beklenmedik bir hata oluştu.');
      });
  };

  const fetchAndShowCoupon = (cmpId, campId) => {
    setCouponError('');
    setCouponLoading(true);
    setCouponData(null);
    setCouponModalOpen(true);

    Services.GetBolParaCoupon(token, cmpId, campId, poiID)
      .then((res) => {
        if (res?.data?.status) {
          setCouponData(res.data.result || res.data);
        } else {
          setCouponError('Kupon alınamadı. Lütfen tekrar deneyin.');
        }
      })
      .catch(() => setCouponError('Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.'))
      .finally(() => setCouponLoading(false));
  };

  // Yardımcı: kapalı günlerden açık günleri üret
  const getOpenDaysFromClosed = () => {
    const open = WEEK_DAYS.filter((d) => !closedDays.includes(d));
    return open.join(', ');
  };

  const handleSendRequest = () => {
    setIsLoading(true);

    if (isAvonTemsilci) {
      const data = [
        {
          name,
          lastname: surname,
          fullName: name + ' ' + surname,
          phone,
        },
      ];
      return sendApplication(data);
    }

    if (isAvonStand) {
      const workingHours =
        workingHoursStart && workingHoursEnd ? `${workingHoursStart} - ${workingHoursEnd}` : '';
      const openDays = getOpenDaysFromClosed();

      const data = [
        {
          name,
          lastname: surname,
          phone,
          fullName: name + ' ' + surname,
          workingHoursStart,
          workingHoursEnd,
          closedDays,
          workingHours,
          openDays,
          hasOneSquareMeter,
        },
      ];
      return sendApplication(data);
    }

    const data = [
      {
        name,
        lastname: surname,
        phone,
        email,
      },
    ];
    return sendApplication(data);
  };

  const isTimeRangeValid = () => {
    if (!workingHoursStart || !workingHoursEnd) return false;
    const toMin = (hhmm) => {
      const [h, m] = hhmm.split(':').map(Number);
      return h * 60 + (m || 0);
    };
    return toMin(workingHoursEnd) > toMin(workingHoursStart);
  };

  const isFormValid = () => {
    const baseValid =
      name.trim() !== '' &&
      surname.trim() !== '' &&
      phone.trim() !== '' &&
      phone.length === 10 &&
      kvkk;

    if (isAvonTemsilci) return baseValid;

    if (isAvonStand) {
      const extraValid = hasOneSquareMeter === 'Evet' || hasOneSquareMeter === 'Hayır';
      return baseValid && extraValid && isTimeRangeValid() && avonStandCheckbox;
    }

    return baseValid;
  };

  const handlePhoneChange = (event) => {
    const input = event.target.value;
    const onlyNumbers = input.replace(/\D/g, '');
    if (onlyNumbers.length <= 10) setPhone(onlyNumbers);
  };

  const toggleClosedDay = (day) => {
    setClosedDays((prev) => (prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]));
  };

  const kvkkHtml = useMemo(() => {
    if (isAvonStand) return kvkkTextAvonStand;
    if (isAvonTemsilci) return kvkkTextAvonTemsilci;
    return kvkkText;
  }, [isAvonStand, isAvonTemsilci]);

  const openAgreementModal = (type) => {
    if (type === 'kvkk') {
      setShowKVKKModal(true);
      setShowAgreementModal(false);
      setModalContent(kvkkHtml);
    }
  };

  useEffect(() => {
    if (showKVKKModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [showKVKKModal]);

  // Kupon modal içeriği
  const renderCouponContent = () => {
    if (couponLoading) {
      return (
        <div className="modal-content-col" style={{ alignItems: 'center' }}>
          <CircularProgress />
          <p style={{ marginTop: 12 }}>Kupon alınıyor…</p>
        </div>
      );
    }
    if (couponError) {
      return (
        <div className="modal-content-col">
          <span className="modal-title">Kupon</span>
          <p style={{ color: '#e11d48', marginTop: 4 }}>{couponError}</p>
          <button className="modal-btn" onClick={() => setCouponModalOpen(false)}>
            <p>Kapat</p>
          </button>
        </div>
      );
    }
    if (!couponData) {
      return (
        <div className="modal-content-col">
          <span className="modal-title">Kupon</span>
          <p>Gösterilecek kupon bulunamadı.</p>
          <button className="modal-btn" onClick={() => setCouponModalOpen(false)}>
            <p>Kapat</p>
          </button>
        </div>
      );
    }

    const code = couponData.code || couponData.couponCode || couponData.CouponCode;
    const title = couponData.title || couponData.campaignTitle || `${companyName} Kuponu`;
    const description = couponData.description || couponData.desc;
    const expireDate = couponData.expireDate || couponData.expiration || couponData.validUntil;
    const qrUrl = couponData.qrUrl || couponData.qrCodeUrl || couponData.qr;

    return (
      <div className="modal-content-col" style={{ gap: 10 }}>
        <span className="modal-title">{title}</span>
        {description && <p style={{ color: '#475569', margin: 0 }}>{description}</p>}

        {code && (
          <div
            style={{
              background: '#f1f5f9',
              border: '1px dashed #94a3b8',
              padding: '12px 16px',
              borderRadius: 8,
              fontWeight: 700,
              letterSpacing: 1.2,
              textAlign: 'center',
              boxSizing: 'border-box',
              width: '100%'
            }}
          >
            {code}
          </div>
        )}

        {expireDate && (
          <p style={{ color: '#64748B', fontSize: 12, margin: 0 }}>
            Son Kullanım: {expireDate}
          </p>
        )}

        {qrUrl && (
          <img
            src={qrUrl}
            alt="Kupon QR Kodu"
            style={{ alignSelf: 'center', maxWidth: 220, height: 'auto' }}
          />
        )}

        {!code && !description && !qrUrl && (
          <pre
            style={{
              background: '#0f172a',
              color: '#e2e8f0',
              padding: 12,
              borderRadius: 8,
              maxHeight: 300,
              overflow: 'auto',
              width: '100%',
            }}
          >
            {JSON.stringify(couponData, null, 2)}
          </pre>
        )}

        <button className="modal-btn" onClick={() => setCouponModalOpen(false)}>
          <p>Tamam</p>
        </button>
      </div>
    );
  };

  return (
    <div className="page-wrap">
      {isLoading ? (
        <CircularProgress />
      ) : (
        <div className="form-container" style={{ overflowY: showKVKKModal ? 'hidden' : 'auto' }}>
          <p className="form-title">
            {campaignTitle} <b>- Kayıt Formu</b>
          </p>

          {/* Grid: mobil 1 sütun, ≥768px 2 sütun */}
          <div className="form-grid">
            {/* İsim */}
            <div className="field">
              <input
                placeholder="İsim *"
                className="input"
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                autoComplete="given-name"
              />
            </div>

            {/* Soyisim */}
            <div className="field">
              <input
                placeholder="Soyisim *"
                className="input"
                type="text"
                id="surname"
                value={surname}
                onChange={(e) => setSurname(e.target.value)}
                autoComplete="family-name"
              />
            </div>

            {/* Telefon */}
            <div className="field">
              <input
                placeholder="Telefon * (5xx xxx xx xx)"
                className="input"
                type="tel"
                id="phone"
                inputMode="numeric"
                pattern="[0-9]*"
                value={phone}
                onChange={handlePhoneChange}
                autoComplete="tel-national"
              />
            </div>

            {/* Diğer tüm kampanyalar: Email alanı */}
            {!isAvonTemsilci && !isAvonStand && (
              <div className="field">
                <input
                  placeholder="E-mail"
                  className="input"
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                />
              </div>
            )}
          </div>

          {/* Avon + Stand: yeni alanlar */}
          {isAvonStand && (
            <div className="stand-section">
              <div className="time-row">
                <div className="time-col">
                  <label className="input-label" htmlFor="workingHoursStart">
                    Çalışma Başlangıç Saati *
                  </label>
                  <input
                    className="input"
                    type="time"
                    id="workingHoursStart"
                    value={workingHoursStart}
                    onChange={(e) => setWorkingHoursStart(e.target.value)}
                  />
                </div>
                <div className="time-col">
                  <label className="input-label" htmlFor="workingHoursEnd">
                    Çalışma Bitiş Saati *
                  </label>
                  <input
                    className="input"
                    type="time"
                    id="workingHoursEnd"
                    value={workingHoursEnd}
                    onChange={(e) => setWorkingHoursEnd(e.target.value)}
                  />
                </div>
              </div>

              {workingHoursStart && workingHoursEnd && !isTimeRangeValid() && (
                <div className="error-inline">Lütfen bitiş saatini başlangıcından büyük seçin.</div>
              )}

              <div className="field">
                <label className="input-label">Çalışılmayan Günler (Çoklu Seçim)</label>
                <div className="multiselect-box">
                  {WEEK_DAYS.map((d) => (
                    <label key={d} className="check-item">
                      <input type="checkbox" checked={closedDays.includes(d)} onChange={() => toggleClosedDay(d)} />
                      <span>{d}</span>
                    </label>
                  ))}
                </div>
                <div className="helper-text">Açık günler: {getOpenDaysFromClosed() || '—'}</div>
              </div>

              <div className="field">
                <select
                  className="input"
                  id="hasOneSquareMeter"
                  value={hasOneSquareMeter}
                  onChange={(e) => setHasOneSquareMeter(e.target.value)}
                >
                  <option value="">1 m² alan var mı? *</option>
                  <option value="Evet">Evet</option>
                  <option value="Hayır">Hayır</option>
                </select>
              </div>
            </div>
          )}

          {/* KVKK ve İleti İzni */}
          <div className="agreements">
            <label className="checkBox-container">
              <input type="checkbox" id="kvkk" checked={kvkk} onChange={() => setKvkk(!kvkk)} />
              <span className="check-text" onClick={() => openAgreementModal('kvkk')}>
                6698 Sayılı Kişisel Verilerin Korunması Kanunu Gereğince Aydınlatma Metnini Okudum. Onaylıyorum. *
              </span>
            </label>

            {isAvonStand &&
              <label className="checkBox-container">
                <input type="checkbox" id="followUp" checked={avonStandCheckbox} onChange={() => setAvonStandCheckbox(!avonStandCheckbox)} />
                <span className="check-text">
                  EASY POINT’in yalnızca alan tahsis sürecinde koordinatör konumunda olduğunu; Türk Borçlar Kanunu uyarınca alt kira ilişkisi kuran, kiraya veren veya kiracı sıfatı taşımadığını, dükkân önü alanlarının hukuka aykırı kullanımına ilişkin herhangi bir hukuki veya fiili sorumluluk üstlenmediğini kabul ederim.
                  Stant kurulumu için gerekli olabilecek belediye veya diğer idari mercilerden alınması gereken tüm izin, ruhsat, onay ve benzeri belgelerin tarafımdan temin edileceğini; gerekli izinlere, onaylara ve bu faaliyeti yürütmeye ilişkin yasal yetki ve ehliyete sahip olduğumu kabul, beyan ve taahhüt ederim.
                  Bu yükümlülüklerin yerine getirilmemesinden doğabilecek her türlü idari yaptırım, cezai sorumluluk, üçüncü kişi talepleri veya maddi/manevi zarardan yalnızca benim sorumlu olduğumu ve EASY POINT’in hiçbir sorumluluğu bulunmadığını kabul ederim.
                </span>
              </label>
            }

            <label className="checkBox-container">
              <input type="checkbox" id="followUp" checked={followUp} onChange={() => setFollowUp(!followUp)} />
              <span className="check-text">
                6563 Sayılı Kanun kapsamında AVM Lojistik Ticaret A.Ş. tarafından tarafıma verilmekte olan hizmetler
                kapsamında, herhangi bir iletişim aracı kullanılarak (SMS, e-posta, telefon, faks, çağrı merkezi v.b.)
                tarafıma her türlü bilgilendirme, tanıtım, reklam, ürün teklifleri, promosyon, kampanyalar, memnuniyet
                değerlendirme çalışmaları ve duyuruların iletilmesi amacıyla iletişime geçilmesine açık rıza veriyorum.
              </span>
            </label>
          </div>

          <button onClick={handleSendRequest} disabled={!isFormValid()}>
            <p>Hemen Başvur</p>
          </button>

          <Modal visible={showModal}>
            <div className="modal-content-col">
              <span className="modal-title">Başvuru Sonucu</span>
              <p>{resultMessage}</p>
              <button className="modal-btn" onClick={() => setShowModal(false)}>
                <p>Tamam</p>
              </button>
            </div>
          </Modal>

          {/* KVKK Modal */}
          <Modal visible={showKVKKModal} style={{ maxHeight: '50vh', overflowY: 'auto' }}>
            <div className="kvkk-modal-body">
              <div style={{ fontSize: '12px' }} dangerouslySetInnerHTML={{ __html: modalContent }} />
              <button className="modal-btn" onClick={() => setShowKVKKModal(false)}>
                <p>Tamam</p>
              </button>
            </div>
          </Modal>

          {/* Kupon Modal */}
          <Modal visible={couponModalOpen}>
            {renderCouponContent()}
          </Modal>
        </div>
      )}

      <span className="footer-copy">Copyright ©Easy Point 2024.</span>
    </div>
  );
}

export default Form;